export default [
  'BOTAppointmentConfirmation'
]

/*
Appears on:
/appointment/appointment-confirmation
*/
